<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" title="" />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <div class="case-section-content-list" v-for="(cas,index) in caseList" :key="index">
          <img :src="require(`../assets/test/ys${index + 1}.png`)" alt="Honor Image"/>
          <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{cas.Title}}</p>
            <p class="abstract-content">{{cas.Content}}</p>
          </div>
        </div>
        <!-- 生命周期 -->
      <div class="smzq">
        <h2 style="text-align: center;margin-top: 3%;color: #14679f;">4.{{$t("message.bmtext17")}}</h2>
        <el-steps :active="5" class="smzq-c">
          <el-step title="" icon="el-icon-right"></el-step>
          <el-step title="" icon="el-icon-right"></el-step>
          <el-step title="" icon="el-icon-right"></el-step>
          <el-step title="" icon="el-icon-right"></el-step>
          <el-step title="" icon="el-icon-right"></el-step>
        </el-steps>
        <div class="smzq-a">
          <div class="smzq-b">
            <img src="../assets/test/smzq1.png" alt="">
            <h3>{{$t("message.bmtext7")}}</h3>
            <p>{{$t("message.bmtext8")}}</p>
          </div>
          <div class="smzq-b">
            <img src="../assets/test/smzq2.png" alt="">
            <h3>{{$t("message.bmtext9")}}</h3>
            <p>{{$t("message.bmtext10")}}</p>
          </div>
          <div class="smzq-b">
            <img src="../assets/test/smzq3.png" alt="">
            <h3>{{$t("message.bmtext11")}}</h3>
            <p>{{$t("message.bmtext12")}}</p>
          </div>
          <div class="smzq-b">
            <img src="../assets/test/smzq4.png" alt="">
            <h3>{{$t("message.bmtext13")}}</h3>
            <p>{{$t("message.bmtext14")}}</p>
          </div>
          <div class="smzq-b">
            <img src="../assets/test/smzq5.png" alt="" >
            <h3>{{$t("message.bmtext15")}}</h3>
            <p>{{$t("message.bmtext16")}}</p>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: false,
      imgid: 0,
    };
  },
  mounted() {
  },
  computed:{
    caseList(){
      return [
      {Id: 1,Img: '../assets/test/ys1.png',Title: this.$t("message.bmtext1"),Content: this.$t("message.bmtext2")},
      {Id: 2,Img: '../assets/test/ys2.png',Title: this.$t("message.bmtext3"),Content: this.$t("message.bmtext4")},
      {Id: 3,Img: '../assets/test/ys3.png',Title: this.$t("message.bmtext5"),Content: this.$t("message.bmtext6")},
        // 可以继续添加更多案例
        ]
    }
  }
};
</script>

 <style lang="scss" scoped>
 //生命周期
.smzq{
  width: 100%;
  height: 580px;
  //border: red solid 1px;
  font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  margin-top: 10%;
}
.smzq-a{
  display:  flex;
  // align-items: center;
  // justify-content: center;
  //border-bottom: gray solid 5px;
}
.smzq-b{
  width: 200px;
  margin: 3% auto;
  border-bottom: rgb(19, 108, 209) solid 4px;
  img{
    margin: 0 30%;
  }
  p{
    text-align: center;
  }
  h3{
    text-align: center;
  }
}
.smzq-c{
  margin: 3% 3%;
  margin-bottom: 0;
}
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-color: #14679f;
  //background: linear-gradient( rgb(36, 143, 243), rgb(221, 166, 95));
  
  &-section {
    width: 100%;
    &-content {
      width: 1450px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 2px solid #14679f;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          margin: 0 35px;
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 25px;
            color: #14679f;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;
            
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 3px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>